<script setup>
import PdfViewer from '@templates/pdfViewer/PdfViewer.vue';
import { url } from '@/config/urls';

</script>

<template>
    <PdfViewer title="バーコードスキャン機能利用規約" :api-url=url.api.barcodeScanTerms.pdf :printable="false" />
</template>